
// export const axiosPath = (string) => typeof window !== "undefined" && window.document && window.document.createElement ? string : `${process.env.REACT_APP_HOME_URL}${ string }`;
import { isSSR } from "./isSSR";

export const axiosPath = (string) => isSSR() ? `${process.env.REACT_APP_SSR_API_URL}${ string }` : string;
